import React from 'react'
import { MoonLoader } from 'react-spinners'
import './style.scss'

const Index = () => {
    return(
        <div className="load-contact-container">
            <div className="inner-load-contact-container">
                <div className="loader">
                    <MoonLoader
                    size={40}
                    color={"#123abc"}
                    loading={true}
                    />
                </div>
                <h2 className="empty-title">Laster inn</h2>
                <p className="empty-description">Vennligst vent mens kontaktlisten laster. Her vil detaljer for hver valgte kontakt vises.</p>
            </div>
        </div>
    )
}

export default Index